import Axios, { axiosInstance } from './axios'
import interceptors from './interceptor'
import { configUrl } from '@/lib/configUrl'
// 没有拦截器的实例axios实例
const ppAxiosInstance = Axios.create({
	baseURL: configUrl,
	headers: {
		accessToken: window.sessionStorage.getItem('accessToken')
	}
})

// 大数据埋点 axios实例
// const instancedateDp = Axios.create({
//   baseURL: dataDepUrl
// })

// 添加拦截器
// axios实例
const instance = Axios.create({
	baseURL: configUrl
})
instance.interceptors.request.use(
	interceptors.request.success,
	interceptors.request.error
)
instance.interceptors.response.use(
	interceptors.response.success,
	interceptors.response.error
)
export { instance, ppAxiosInstance }
// 请求封装
export const sendRequest = ([method, url], params, options) =>
	axiosInstance(instance, [method, url], params, options)
// 请求封装(不带拦截器)
export const ppAxios = ([method, url], params, options) =>
// ppAxiosInstance({ method, url, params, ...options });
	axiosInstance(ppAxiosInstance, [method, url], params, options)
// 大数据封装
// export const dateDpsendRequest = ([method, url], params, options) =>
// 	axiosInstance(instancedateDp, [method, url], params, options)

// api配置
export const apiConf = {
	configUrl,

	commonError: ['999999', '系统繁忙，请稍后再试'],

	/** -----------  全局系统相关 api -------------- */
	userApi: {
		// 用户登录
		getLoginInfo: ['POST', '/merchant/acquirer/user/login'],
		// 用户登出
		getLogoutInfo: ['POST', '/merchant/acquirer/user/logout'],
		// new: addTempAccount
		addTempAccount: ['POST', '/merchant/acquirer/user/addTempAccount'],
		// 用户注册
		userRegister: ['POST', '/merchant/acquirer/user/register'],
	 // 用户注册->绑定acquirer
		bindAcquirer: ['POST', '/merchant/acquirer/user/bindAcquirer'],
		// 用户注册->发送短信验证码
		registerSendMsg: ['POST', '/merchant/acquirer/user/registerSendMsg'],
		// 用户注册->发送邮件验证码
		registerSendEmail: ['POST', '/merchant/acquirer/user/registerSendEmail'],
		// 重置密码
		resetPwd: ['POST', '/merchant/acquirer/user/resetPwd'],
		// 初次登陆->发送短信验证码
		loginSendMsg: ['POST', '/merchant/acquirer/user/loginSendMsg'],
		// 初次登陆设置密码
		loginSetPwd: ['POST', '/merchant/acquirer/user/loginSetPwd'],
		// 账号中心
		accountCenter: ['POST', '/merchant/acquirer/user/accountCenter'],
		// 忘记密码--校验注册邮箱是否可用
		emailCheck: ['POST', '/merchant/acquirer/user/emailCheckCode'],
		// 忘记密码--发送邮件验证码
		resetPwdSendMsg: ['POST', '/merchant/acquirer/user/resetPwdSendEmail'],
		// 用户中心数据获取
		getAccountCenterInfo: ['POST', '/merchant/acquirer/user/accountCenter'],
		// 获取geetest极验初始化配置
		getGeeTestParams: ['POST', '/merchant/acquirer/auth/getGeeTestParams'],
		// 获取geetest二次验证
		getGeeTestValidate: ['POST', '/merchant/acquirer/auth/geeTestValidate'],
		// 收益账号验证->验证码
		beneficiarySendMsg: ['POST', '/merchant/acquirer/user/beneficiarySendMsg'],
		// 添加收益账号
		addbeneficiary: ['POST', '/merchant/acquirer/beneficiary/add'],
		// 修改收益账号
		updatebeneficiary: ['POST', '/merchant/acquirer/beneficiary/update'],
		// 查询处于打款中的结算记录
		getInProcessList: ['POST', '/merchant/acquirer/withdraw/getInProcessList']

	},
	/** -----------  网站管理相关 api -------------- */
	webSiteApi: {
		// 网站总揽
		getWebSiteOverview: ['POST', '/merchant/acquirer/payment/webSiteOverview'],
		// 网站列表
		getWebListInfo: ['POST', '/merchant/acquirer/store/list'],
		// 网站详情
		getStoreSelectOne: ['POST', '/merchant/acquirer/store/selectOne'],
		// 获取交易记录列表
		getShopDetail: ['POST', '/merchant/acquirer/tradeNew/list'], // "/merchant/acquirer/trade/list"],
		// 获取交易记录导出url
		getTradeExportURL: ['POST', '/merchant/acquirer/payment/trade_export'],
		// 获取待入账记录列表
		getPreInboundData: ['POST', '/merchant/acquirer/account/balance/list'],
		// 获取待入账记录导出url
		getPreInboundExportURL: [
			'POST',
			'/merchant/acquirer/payment/preInboundAmountCurrency_exp'
		],
		// 获取保证金明细
		getDepositData: ['POST', '/merchant/acquirer/account/deposit/list'],
		// 获取保证金明细导出
		getDepositExportURL: [
			'POST',
			'/merchant/acquirer/payment/depositDetail_exp'
		],
		// // 网站管理账户余额信息
		getAccountBalance: ['POST', '/merchant/acquirer/account/balance'],
		// 获取交易详情
		getTradeDetail: ['POST', '/merchant/acquirer/trade/detail'],
		// 取消交易
		cancleTrade: ['POST', '/merchant/acquirer/payment/reversal'],
		// 预授权确认
		confirmTrade: ['POST', '/merchant/acquirer/payment/preAuthorize'],
		// 退款
		returnTrade: ['POST', '/merchant/acquirer/payment/refund'],
		arrowRefund: ['GET', '/merchant/chargeBack/dataAuth'],
		getArrowRefund: ['GET', 'merchant/acquirer/payment/getRefund'],
		// 提现记录
		getWithdrawRacdList: [
			'POST',
			'/merchant/acquirer/payment/getWithdrawRacdList'
		],
		// 提现记录导出
		getWithdrawRacdExportURL: [
			'POST',
			'/merchant/acquirer/payment/withdrawExp'
		],
		// 提现网站
		getWithdrawWebsite: [
			'POST',
			'/merchant/acquirer/payment/getWithdrawWebsite'
		],
		// 查看今日打款
		getTodayWithdraw: ['POST', '/merchant/acquirer/trade/getTodayWithdraw'],
		// 提现
		doWithdraw: ['POST', '/merchant/acquirer/withdraw/doProcess'],
		// 提现校验
		withdrawVerify: ['POST', '/merchant/acquirer/withdraw/withdrawVerify'],
		// 获取交易状态和交易记录
		getTransactionFundStatus: ['POST', '/merchant/dictionary'],
		// 获取查询商户属性
		getClientProperty: ['GET', '/merchant/queryClientProperty'],
		// 保存商户属性
		saveClientProperty: ['GET', '/merchant/saveClientProperty'],
		// 交易状态枚举
		dictionary: ['POST', '/merchant/dictionary'],
		// 审核接口
		paymentReview: ['POST', '/merchant/acquirer/payment/review'],
		// 获取 X-Man 渠道下银行列表
		getXManPayBank: ['GET', '/merchant/acquirer/payment/getXManPayBank']
	},
	/** -----------  打款记录 api -------------- */
	recordApi: {
		// 查询打款记录列表
		loadWithdrawList: ['POST', '/merchant/acquirer/withdraw/list'],
		// 获取打款网站
		getWithdrawStoreList: ['POST', '/merchant/acquirer/withdraw/storeList'],
		// 查询提现记录
		loadSelfWithdrawList: ['POST', '/merchant/acquirer/withdraw/selfList']
	},

	/** -----------  数据上报 api -------------- */
	dataReportApi: {
		// 交易
		selectData: ['POST', 'merchant/data/selectData'],
		// 审核通过的网站列表
		storeList: ['POST', '/merchant/data/storeList'],
		// 交易分析
		tradeAnalysis: ['POST', '/merchant/dashboard/transAnalysis'],
		// 交易国家分布
		tradeCountry: ['POST', '/merchant/dashboard/transCountry'],
		// 退款分析
		refundAnalysis: ['POST', '/merchant/dashboard/refundAnalysis'],
		// 拒付率分析
		cbRatioAnalysis: ['POST', '/merchant/dashboard/cbRatio'],
		// 拒付原因分析
		cbRatioReason: ['POST', '/merchant/dashboard/cbReason'],
		// 拒付预警分析
		cbAlert: ['POST', '/merchant/dashboard/cbAlert']
	},

	/** -----------  结算报表 api -------------- */
	settlementApi: {
		// 结算报表
		selectSettlementData: ['POST', '/merchant/data/selectPage'],
		// 审核通过的网站列表
		storeList: ['POST', '/merchant/data/storeList'],
		// 导出excel表格
		exportExcel: ['POST', '/merchant/data/exportExcel']
	},
	/** -----------  实名认证 api -------------- */
	certificationApi: {
		// 文件上传
		uploadFile: ['POST', '/merchant/acquirer/file/upload'],
		// 下载文件
		downloadFile: ['GET', '/merchant/acquirer/file/downLoad'],
		// 个人信息服务
		personal: ['POST', '/merchant/acquirer/certification/personal'],
		// 公司信息服务
		company: ['POST', '/merchant/acquirer/certification/company'],
		// kyc修改状态
		kycSubmit: ['POST', '/merchant/acquirer/certification/commitChange'],
		// 查询
		query: ['POST', '/merchant/acquirer/certification/query'],
		// 查询已添加人物
		getWriter: ['POST', '/merchant/acquirer/certification/oneClickAddUser'],
		// 删除上传图片
		deleteFile: ['POST', 'merchant/acquirer/file/deleteFile'],
		// 获取证件到期弹框信息
		getExpireCertification: ['POST', '/merchant/acquirer/initialization'],
		// 证件到期 - 获取详情数据
		getExpireCertificationDetail: ['GET', '/merchant/acquirer/certification/renew/details'],
		// 证件到期 - 提交修改 - 法人股东受益人
		submitCertificationDetail: ['POST', '/merchant/acquirer/certification/renew/customer/apply'],
		// 证件到期 - 提交修改 - 公司
		submitCertifiCompanyDetail: ['POST', '/merchant/acquirer/certification/renew/company/apply'],
		// 变更法人股东受益人
		customerCreateOrDelete: ['POST', '/merchant/acquirer/certification/renew/customerCreateOrDelete'],
		// 证件变更记录
		updateHistory: ['GET', '/merchant/acquirer/certification/renew/apply/list'],
		// 证件到期提醒列表
		updateRequired: ['GET', '/merchant/acquirer/certification/renew/expired/list'],
		// 法人股东受益人变更
		customerCreateOrDelete: ['POST', '/merchant/acquirer/certification/renew/customerCreateOrDelete']
	},
	/** -----------  实名认证后允许添加网站 api -------------- */
	addWebApi: {
		// 实名认证校验
		checkkycstatus: ['POST', '/merchant/acquirer/bizinfo/checkkycstatus'],
		// 添加网站或者更新
		addmod: ['POST', '/merchant/acquirer/store/addmod'],
		// 获取网站申请表模版查询
		getTemplate: ['GET', '/merchant/acquirer/store/template']
	},
	chargeback: {
		getWebsiteUrl: ['GET', '/merchant/chargeBack/getWebsiteUrl'],
		getChargeBackList: ['POST', '/merchant/chargeBack/list'],
		download: ['POST', '/merchant/chargeBack/list/download'],
		replyOperate: ['POST', '/merchant/chargeBack/replyOperate'],
		getChargebackEnum: ['GET', '/common/getEnum']
	},
	riskApi: {
		getRiskTranscationList: ['GET', '/group/listRisk']
	},
	// pp认证的api
	ppAuthorization: {
		fetchUserWebsite: ['POST', '']
	}
}
// export const dataDepConf = {
// 	dataDepUrl,

// 	commonError: ['999999', '系统繁忙，请稍后再试'],

// 	commonApi: {
// 		buriedPoint: ['POST', '/logbury/api/postLogbury']
// 	}
// }
